export const HEADER_ENAEP = {
    'Content-Type': 'application/json', 
    Authorization:  "Basic YXBwY29uZnVzZXI6cnkha3ZAN0B3RUY3ZyFsTA"
  }
  export const PUT_HEADER = {
    'x-amz-acl': 'bucket-owner-full-control', 
    'Content-Type': 'application/json',  
  }
  export const PUT_HEADER_NCS = {
    'x-amz-acl': 'bucket-owner-full-control', 
    'Content-Type': 'application/octet-stream',  
  }
  export const HEADER_HB = {
    'Content-Type': 'text/plain', 
    Authorization:  "Basic YXBwY29uZnVzZXI6cnkha3ZAN0B3RUY3ZyFsTA"
  }
export const  NOT_AVAILABLE = "NotAvailable";
export const NOT_APPLICABLE = "N/A";
export const MATCH = "Match";
export const MISMATCH = "Mismatch";
export const LoggPrefix = "[ADP Student App]"
